var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRevenue = function SvgRevenue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.861 18.555a2.86 2.86 0 0 1 1.425 2.182c.008.048.016.099.021.147l.041.352 3.032-1.742V0h-4.517v18.555h-.002Z",
    fill: "url(#revenue_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.755 18.195h.004c.089.01.178.023.265.043v-5.814h-4.516v5.73h3.736a2.99 2.99 0 0 1 .511.041Z",
    fill: "url(#revenue_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.154 16.598a9.278 9.278 0 0 1 1.162.408l1.055.45a9.05 9.05 0 0 0 2.3.636V4.74h-4.517v11.859Z",
    fill: "url(#revenue_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.823 16.33c.167.02.332.046.496.075v-6.13h-4.516v5.956h2.63c.465 0 .932.032 1.39.098Z",
    fill: "url(#revenue_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.643 18.685a1.581 1.581 0 0 0-.968-.803 1.584 1.584 0 0 0-1.248.148l-7.358 4.23a6.06 6.06 0 0 1-3.017.806h-6.48a.409.409 0 0 1 0-.817h6.48a5.193 5.193 0 0 0 2.534-.654l.12-.066v-.486a2.224 2.224 0 0 0-.205-.941 2.266 2.266 0 0 0-2.062-1.324h-3.525a9.622 9.622 0 0 1-3.777-.77l-1.055-.45a8.93 8.93 0 0 0-1.756-.54 8.906 8.906 0 0 0-1.7-.165h-4.624c-.523 0-1.047.12-1.518.35l-1.535.748 3.605 7.43h2.371c.716 0 1.417.136 2.081.403L21.53 28.4c.593.238 1.22.358 1.864.358a4.995 4.995 0 0 0 2.585-.72l12.066-7.256c.716-.431.98-1.353.598-2.098Z",
    fill: "#F5B826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01 30c.255 0 .517-.056.76-.176l2.691-1.307a1.753 1.753 0 0 0 .812-2.338l-4.258-8.776a1.739 1.739 0 0 0-1.575-.987c-.262 0-.521.06-.763.176L.987 17.9a1.753 1.753 0 0 0-.812 2.338l4.257 8.776c.302.623.927.987 1.578.987ZM2.047 19.573a1.47 1.47 0 1 1 2.938 0 1.47 1.47 0 0 1-2.938 0Z",
    fill: "#C2921F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "revenue_svg__a",
    x1: 30.12,
    y1: 0,
    x2: 30.12,
    y2: 21.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "revenue_svg__b",
    x1: 24.766,
    y1: 12.424,
    x2: 24.766,
    y2: 18.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "revenue_svg__c",
    x1: 19.413,
    y1: 4.739,
    x2: 19.413,
    y2: 18.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "revenue_svg__d",
    x1: 14.061,
    y1: 10.276,
    x2: 14.061,
    y2: 16.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B826",
    stopOpacity: 0
  })))));
};

export default SvgRevenue;